import { useLayoutEffect } from 'react';
import {
  activatedAnimationName,
  animationNames,
  cancelAnimationName,
  completedAnimationName,
  delayedAnimationName,
  aperiodicAnimationName,
  spontaneousAnimationName,
  grilledAnimationName,
  estimateTagAnimationName,
  aperiodicEstimateTagAnimationName,
  spontaneousEstimateTagAnimationName,
  grilledEstimateTagAnimationName,
} from '../constants';

// Progress widths and estimate tags share a phase. Other status effects
// synchronize only with animations of the same kind.
const ANIMATION_GROUPS = [
  [
    ...animationNames,
    estimateTagAnimationName,
    aperiodicEstimateTagAnimationName,
    spontaneousEstimateTagAnimationName,
    grilledEstimateTagAnimationName,
  ],
  [cancelAnimationName],
  [activatedAnimationName],
  [delayedAnimationName],
  [completedAnimationName],
  [aperiodicAnimationName],
  [spontaneousAnimationName],
  [grilledAnimationName],
];

const synchronizeGroup = animations => {
  const baseTime = animations.find(animation => animation.currentTime != null)?.currentTime;
  
  if (baseTime == null) {
    return;
  }

  animations.forEach(animation => {
    animation.currentTime = baseTime;
  });
};

const synchronizeTable = table => {
  const animations = table.getAnimations({ subtree: true });
  
  ANIMATION_GROUPS.forEach(names => {
    synchronizeGroup(animations.filter(animation => names.includes(animation.animationName)));
  });
};

export default function useSyncAnimations(rows, tableRef) {
  useLayoutEffect(() => {
    let frameId;
    let cancelled = false;
    
    const synchronize = () => {
      cancelAnimationFrame(frameId);
      
      if (document.hidden || cancelled) {
        return;
      }
      
      // Wait for CSS animations to join the timeline, keeping only one
      // pending synchronization per table, including after visibility changes.
      frameId = requestAnimationFrame(() => {
        if (document.hidden || cancelled) {
          return;
        }
        
        frameId = requestAnimationFrame(() => {
          if (document.hidden || cancelled) {
            return;
          }
          
          if (tableRef.current) {
            synchronizeTable(tableRef.current);
          }
        });
      });
    };
    
    synchronize();
    document.addEventListener('visibilitychange', synchronize);
    
    return () => {
      cancelled = true;
      cancelAnimationFrame(frameId);
      document.removeEventListener('visibilitychange', synchronize);
    };
  }, [rows, tableRef]);
}
